import React from 'react';
import { PreviewItemContainer, PreviewWorkoutItemImage } from '../style';
import { Text } from '../../../../UI/Text';
import { convertWorkoutTypePreviewKeyToTitle, convertWorkoutTypePreviewKeyToDescription } from '../utils';
import { Icon } from '../../../Icons/Icons';
import { colorNames } from '../../../../../Constants/colors';

export const WorkoutTypePreviewItem = ({ type, selectItem, isDisabled }) => {
    return (
        <PreviewItemContainer>
            <PreviewWorkoutItemImage disabled={isDisabled} onClick={isDisabled ? null : selectItem}>
                <PreviewImageIconFactory type={type} />
            </PreviewWorkoutItemImage>
            <Text marginBottom={'4px'} alignCenter={true} weight={'bold'}>
                {convertWorkoutTypePreviewKeyToTitle(type)}
            </Text>
            <Text marginBottom={'16px'} alignCenter={true} fontSize={12} color={colorNames.GREY}>
                {convertWorkoutTypePreviewKeyToDescription(type)}
            </Text>
        </PreviewItemContainer>
    );
};

const PreviewImageIconFactory = ({ type }) => {
    switch (type) {
        case 0:
            return <Text fontSize={40}>💪</Text>;
        case 1:
            return <Text fontSize={40}>🏆</Text>;
        case 2:
            return (
                <Icon.Box opacity={0.75} size={'40x40'}>
                    <Icon.Edit />
                </Icon.Box>
            );
        default:
            return <Text>Something went wrong</Text>;
    }
};

WorkoutTypePreviewItem.defaultProps = {
    type: 0,
};



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/GymTvConfigurationsModal/Previews/WorkoutTypePreviewItem.js